<template>
    <div class="supplier">
<!--        <el-card>-->
<!--            <el-breadcrumb separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>权限管理</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>供应商管理</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm" size="mini">
                    <el-form-item label="邮箱">
                        <el-input v-model="searchForm.email" placeholder="邮箱" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="姓名">
                        <el-input v-model="searchForm.name" placeholder="姓名" size="mini" clearable></el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
                <div ref="tablePosition"></div>
                 <el-table
                    size="mini"
                    stripe
                    :data="tableData"
                    v-loading="loading"
                    :height="tableConfig.height"
                    style="width: 100%">
                    <el-table-column
                        prop="email"
                        label="邮箱">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="姓名"
                        width="300">
                    </el-table-column>
                    <el-table-column
                        prop="mobile"
                        label="手机号"
                        width="180">
                    </el-table-column>

                    <el-table-column
                        prop="company"
                        label="供应商公司"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="status"
                        label="状态"
                        width="100">
                        <template slot-scope="scope">
                            <el-tag size="mini"
                                :type="scope.row.status ===  1 ? 'primary' : 'info'"
                                disable-transitions>{{scope.row.status === 1 ? "有效" : "无效" }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="350" align="right">
                        <template slot="header">
                            <el-button type="primary" @click="handleCreateUser" size="mini">添加</el-button>
                        </template>
                        <template slot-scope="scope">

                            <el-button
                                    size="mini" type="text"
                                    @click="handleEditRole(scope.$index, scope.row)">设置公司</el-button>
                            <el-divider direction="vertical" ></el-divider>
                            <el-button
                                size="mini" type="text"
                                @click="handleEdit(scope.$index, scope.row)">编辑信息</el-button>
                            <el-divider direction="vertical" ></el-divider>

                            <el-dropdown size="mini" >
                                <div style="">
                                     <span class="el-dropdown-link" style="font-size: 12px;vertical-align: middle;line-height: 28px;" >
                                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                                  </span>
                                </div>

                                <el-dropdown-menu slot="dropdown">

                                    <el-dropdown-item>
                                        <el-button
                                                size="mini" type="text"
                                                @click="handleResetPassword(scope.$index, scope.row)" style="width: 100%;text-align: left;">重置密码</el-button>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <el-button
                                                size="mini"
                                                type="text" style="color: red;width: 100%;text-align: left;"
                                                @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>

                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                        background
                        layout="sizes,prev, pager, next"
                        :page-sizes="[10, 20, 50, 100]"
                        v-if="total>0"
                        :total="total"
                        :page-size="pageSize"
                        @size-change="handleSizeChange"
                        @current-change="onPageChange"
                        :current-page="currentPage"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
        <el-dialog title="供应商信息" :visible.sync="editDialogVisible" :close-on-click-modal="false" width="500px">
            <el-form ref="editForm" :model="editForm" :rules="rules" label-width="90px" size="mini">
                <el-form-item label="邮箱" prop="email">
                    <el-input v-model="editForm.email" placeholder="请输入邮箱" clearable></el-input>
                </el-form-item>
                <el-form-item label="密码" v-if="editForm.id === ''" prop="iPassword">
                    <el-input v-model="editForm.iPassword" show-password placeholder="请输入密码" clearable></el-input>
                </el-form-item>
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="editForm.name" placeholder="请输入姓名" clearable></el-input>
                </el-form-item>
                <el-form-item label="手机">
                    <el-input v-model="editForm.mobile" placeholder="请输入手机" clearable></el-input>
                </el-form-item>

                <el-form-item label="状态" prop="status">
                    <el-select v-model="editForm.status" placeholder="请选择账号状态" clearable>
                        <el-option label="无效" value="0"></el-option>
                        <el-option label="有效" value="1"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false" size="mini">取 消</el-button>
                <el-button type="primary" @click="onSubmit" size="mini">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="重置密码" :visible.sync="mdyPasswordDialogVisible" :close-on-click-modal="false" width="500px">
            <el-form ref="editForm" :model="editForm" :rules="rules" label-width="120px">
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="editForm.name" :disabled="true" clearable></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="iPassword">
                    <el-input v-model="editForm.iPassword" show-password placeholder="请输入密码" clearable></el-input>
                </el-form-item>
                <el-form-item label="再次输入密码" prop="rPassword">
                    <el-input v-model="editForm.rPassword" show-password placeholder="请再次输入密码" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="mdyPasswordDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onMdyPassword">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="设置公司" :visible.sync="editRoleVisible" :close-on-click-modal="false" width="500px">
            <el-form ref="editForm" :model="editForm" :rules="rules" label-width="60px">
                <el-form-item label="公司" prop="company">
                    <el-autocomplete
                            v-model="editForm.company"
                            :fetch-suggestions="querySearchCompany"
                            placeholder="请输入公司"
                            style="width: 100%;"
                    ></el-autocomplete>
                </el-form-item>
                <el-form-item>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editRoleVisible = false">取 消</el-button>
                <el-button type="primary" @click="onMdyRole">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
const HEIGHT_OFFSET = 118;
export default {
    data() {
        return {
            pageLoading: undefined,
            tableConfig: {
                height: 0,
            },
            searchForm: {
                type: "",
                email: "",
                name: "",
                mobile: "",
                iPassword: "",
                status: "",
            },
            statusOptions: [
                {
                    value: "",
                    label: "全部",
                },
                {
                    value: "0",
                    label: "无效",
                },
                {
                    value: "1",
                    label: "有效",
                },
            ],
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],
            editDialogVisible: false,
            editForm: {
                id: "",
                name: "",
                email: "",
                mobile: "",
                iPassword: "",
                rPassword: "",
                type: "",
                dataAuth: "",
                company: "",
                companyId: "",
                review: false,
                status: "1",
                role: "",
            },
            mdyPasswordDialogVisible: false,
            editRoleVisible: false,
            roles: [],
            role: "",
            staffId: "",
            rules: {
                email: [
                    { required: true, message: '请输入邮箱', trigger: 'blur' },
                    {
                        pattern: /^\s*((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\s*$/i,
                        message: '请输入正确的邮箱地址',
                    }
                ],
                iPassword: [
                    { required: true, message: '请输入密码', trigger: 'blur' }
                ],
                rPassword: [
                    { required: true, message: '请输入密码', trigger: 'blur' }
                ],
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                type: [
                    { required: true, message: '请选择账号类型', trigger: 'blur' }
                ],
                status: [
                    { required: true, message: '请选择状态', trigger: 'blur' }
                ],
                role: [
                    { required: true, message: '请选择角色', trigger: 'blur' }
                ],
                company: [
                    { required: true, message: '请选择公司', trigger: 'blur' }
                ],
            },
        }
    },
    methods: {
        onSearch() {
            let staff = {
            };
            if(this.searchForm.email != "") {
                staff["email"] = this.searchForm.email;
            }
            if(this.searchForm.name != "") {
                staff["name"] = this.searchForm.name;
            }
            if(this.searchForm.type != "") {
                staff["type"] = this.searchForm.type;
            }
            if(this.searchForm.status != "") {
                staff["status"] = this.searchForm.status;
            }

            this.loading = true;
            let _this = this
            this.$axios.post("/admin/supplier/search",{
                cond: staff,
                page: this.currentPage - 1,size:this.pageSize
            }).then(function(response) {
                let resp = response.data;
                if(resp.header.status == 0) {
                    _this.loading = false;
                    _this.tableData = resp.data.content;
                    _this.total = resp.data.totalElements;
                }
            }).catch(function() {
            });
        },
        handleCreateUser() {
            this.editForm.id = "";
            this.editForm.name = "";
            this.editForm.email = "";
            this.editForm.mobile = "";
            this.editForm.iPassword = "";
            this.editForm.type = "";
            this.editForm.dataAuth = "";
            this.editForm.company = "";
            this.editForm.review = false;
            this.editForm.status = "1";
            this.editDialogVisible = true;
        },
        onSubmit() {
            let that = this;
            this.$refs.editForm.validate(valid => {
                if (valid) {
                    if(this.editForm.type === "1") {
                        this.editForm.company = "";
                    }
                    if(this.editForm.type === "2") {
                        this.editForm.review = "";
                    }
                    this.$axios.post("/admin/supplier", this.editForm)
                    .then(function(response){
                        let resp = response.data;
                        if(resp.header.status == 0) {
                            that.$notify({
                                title: '成功',
                                message: '数据保存成功',
                                type: 'success'
                            });
                            that.editDialogVisible = false;
                            that.onSearch();
                        } else {
                            that.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
                }
            });
        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        handleEditRole(index, row) {
            let that = this;
            this.editForm.id = row.id;
            this.editForm.company =  row.company;
            this.editForm.companyId = row.companyId;
            that.editRoleVisible = true;
        },
        querySearchCompany(queryString, cb) {
            if(queryString) {
                this.$axios.get("/admin/companies/"+queryString)
                    .then(response => {
                        let resp = response.data;
                        if(resp.header.status == 0) {
                            cb(resp.data.map(it => {
                                return {
                                    value: it,
                                };
                            }));
                        }
                    }).catch(()=>{
                })
            }
        },
        handleEdit(index, row) {
            this.editForm.id = row.id;
            this.editForm.name = row.name;
            this.editForm.email = row.email;
            this.editForm.mobile = row.mobile;
            this.editForm.company = row.company;
            this.editForm.type = row.type + "";
            this.editForm.dataAuth = "";
            this.editForm.review = row.review;
            this.editForm.status = row.status + "";
            this.editDialogVisible = true;
        },
        handleDelete(index, row) {
            let that = this;
            this.$confirm('是否删除用户【' + row.name + '】？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '删除',
                cancelButtonText: '取消'
            }).then(() => {
                that.$axios.get("/admin/supplier/delete/" + row.id)
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status === 0) {
                        that.$notify({
                            title: '成功',
                            message: '数据删除成功',
                            type: 'success'
                        });
                        that.onSearch();
                    } else {
                        that.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                });
            })
        },
        handleResetPassword(index, row) {
            this.editForm.name = row.name;
            this.editForm.id = row.id;
            this.editForm.iPassword = "";
            this.editForm.rPassword = "";
            this.mdyPasswordDialogVisible = true;
        },
        onMdyPassword() {
            let that = this;
            this.$refs.editForm.validate(valid => {
                if (valid) {
                    this.$axios.post("/admin/supplier/resetPassword", this.editForm)
                    .then(function(response) {
                        let resp = response.data;
                        if(resp.header.status === 0) {
                            that.$notify({
                                title: '成功',
                                message: '密码修改成功',
                                type: 'success'
                            });
                            that.onSearch();
                            that.mdyPasswordDialogVisible = false;
                        } else {
                            that.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    })
                }
            });
        },
        onMdyRole() {
            let that = this;
            this.$refs.editForm.validate(valid => {
                if (valid) {
                    this.$axios.post("/admin/supplier/company",{
                        id: this.editForm.id,
                        company: this.editForm.company,
                    }).then(function(response) {
                        let resp = response.data;
                        if(resp.header.status == 0) {
                            that.$notify({
                                title: '成功',
                                message: '设置公司成功',
                                type: 'success'
                            });
                            that.onSearch();
                        } else {
                            that.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                        that.editRoleVisible = false;
                    })
                }
            });
        },

        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        }
    },
    created() {
        this.onSearch()

        window.addEventListener("resize", this.setTableHeight);
    },
    mounted() {
        this.pageLoading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
            this.setTableHeight();
            this.pageLoading.close();
            this.pageLoading = undefined;
        }, 500);
    },
    beforeDestroy() {
        if(this.pageLoading){
            this.pageLoading.close();
            this.pageLoading = undefined;
        }
    },
    destroyed () {
        window.removeEventListener("resize", this.setTableHeight);
    }
}
</script>
<style>
</style>
